<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">{{ $t('panelCliente.historialTitulo') }}</h6>
              <p class="text-xs opacity-7 mb-0">Total: <b>{{ pedidos.length }}</b></p>
            </div>
          </div>

          <div v-if="pedidos.length === 0" class="alert alert-secondary text-sm mb-0">
            {{ $t('panelCliente.historialVacio') }}
          </div>

          <div v-else class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th>{{ $t('panelCliente.referencia') }}</th>
                  <th>{{ $t('panelCliente.producto') }}</th>
                  <th>{{ $t('panelCliente.canal') }}</th>
                  <th>{{ $t('panelCliente.fecha') }}</th>
                  <th class="text-center">{{ $t('panelCliente.estado') }}</th>
                  <th class="text-center">{{ $t('panelCliente.devolucion') }}</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="p in paginados" :key="p.pedido_id">
                  <td>{{ p.referencia || "-" }}</td>
                  <td>{{ p.producto?.nombre || "-" }}</td>
                  <td>{{ p.canal?.nombre || "-" }}</td>
                  <td>{{ fmtFechaHora(p.fecha) }}</td>
                  <td class="text-center">
                    <span class="badge" :class="claseEstado(p.estado_codigo)">{{ p.estado || "-" }}</span>
                  </td>
                  <td class="text-center">
                    <span v-if="p.devolucion">
                      <span class="badge badge-info">{{ $t('panelCliente.devolucionSolicitada') }}</span>
                      <span class="d-block text-xs opacity-7">{{ p.devolucion.status || "-" }}</span>
                    </span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="paginacion-panel-cliente">
              <div class="paginacion-info text-xs opacity-7">
                {{ $t('panelCliente.historialPagInfo', { desde, hasta, total: pedidos.length }) }}
              </div>
              <div class="paginacion-botones">
                <button type="button" class="btn btn-paginacion" :disabled="page === 1" @click="page = 1">&lt;&lt;</button>
                <button type="button" class="btn btn-paginacion" :disabled="page === 1" @click="page--">&lt;</button>
                <span class="pagina-actual">{{ $t('panelCliente.paginaDeTotal', { page, total: totalPages }) }}</span>
                <button type="button" class="btn btn-paginacion" :disabled="page === totalPages" @click="page++">&gt;</button>
                <button type="button" class="btn btn-paginacion" :disabled="page === totalPages" @click="page = totalPages">&gt;&gt;</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelClienteHistorial",
  props: {
    pedidos: { type: Array, default: () => [] },
  },
  data() {
    return { page: 1, perPage: 5 };
  },
  watch: {
    pedidos() { this.page = 1; },
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.pedidos.length / this.perPage)); },
    paginados() {
      const start = (this.page - 1) * this.perPage;
      return this.pedidos.slice(start, start + this.perPage);
    },
    desde() { return this.pedidos.length === 0 ? 0 : (this.page - 1) * this.perPage + 1; },
    hasta() { return Math.min(this.page * this.perPage, this.pedidos.length); },
  },
  methods: {
    claseEstado(codigo) {
      const map = { C: "badge-ok", P: "badge-warn", F: "badge-err", R: "badge-info", A: "badge-muted" };
      return map[codigo] || "badge-muted";
    },
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      try {
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        const locale = this.$i18n?.locale === 'en' ? 'en-GB' : 'es-ES';
        return d.toLocaleString(locale);
      } catch { return fechaStr; }
    },
  },
};
</script>

<style scoped>
.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 6px 18px rgba(0,0,0,.06); overflow: hidden; }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.paginacion-panel-cliente { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; margin-top: 16px; padding-top: 10px; }
.paginacion-botones { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.btn-paginacion { min-width: 38px; height: 38px; padding: 0 10px; border: 0; border-radius: 10px; background: var(--q-gold); color: var(--q-gold-on); font-weight: 700; box-shadow: 0 4px 10px rgba(0,0,0,.12); }
.btn-paginacion:disabled { opacity: .45; cursor: not-allowed; box-shadow: none; }

.badge { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; }
.badge-ok   { background: var(--q-green-soft); color: var(--q-green);  border: 1px solid var(--q-green); }
.badge-warn { background: var(--q-amber-soft); color: var(--q-amber);  border: 1px solid var(--q-amber); }
.badge-err  { background: var(--q-red-soft);   color: var(--q-red);    border: 1px solid var(--q-red); }
.badge-info { background: rgba(0,188,212,.12);  color: #00bcd4;         border: 1px solid #00bcd4; }
.badge-muted{ background: var(--q-hover);       color: var(--q-muted);  border: 1px solid var(--q-border-md); }
.pagina-actual { font-size: 13px; font-weight: 600; color: var(--q-text); }

@media (max-width: 768px) {
  .paginacion-panel-cliente { flex-direction: column; align-items: flex-start; }
}
</style>
